import React from 'react';
import dollars from '../../dollar-format';
import {dateISOtoUS} from '../../date-converter';
import { parseArcimedesDate, effectiveLeaseExpirationDate } from '../../utils/leaseExpiration';
import { peakStatusOf, toMediaUrl } from '../../utils';
import {blueHscLogo, hscLogo, summitWhiteLogo} from "../../consts/consts";
import { pricePerFoot } from '../CRUDProperty/CRUDProperty';

const noPropertiesPerPage = 9;

function integer(value) {
    if (value === undefined || value === null || value === '') return '';
    return Math.round(Number(value)).toLocaleString();
}


function percent(value, withDecimals = true) {
    if (value === undefined || value === null || value === '') return '';
    if (withDecimals)
        return Number(value).toFixed(2) + '%';
    return parseInt(value) + '%';
}
function capitalizeFirstLetter(str){
    return str[0].toUpperCase() + str.slice(1);
}

const MS_PER_YEAR = 1000 * 60 * 60 * 24 * 365;

/**
 * Remaining lease term at close (years) = lease expiration minus close of escrow.
 * Same basis as the main list "Remaining Term" column (Financials / PROPERTY fields).
 * Returns null if either date is missing; 'Expired' if expiration is on or before close.
 */
function remainingLeaseTermAtClose(el) {
    if (el.TYPE !== 'STNL') return { display: '', years: null };
    if (!el.CLOSE_OF_ESCROW) {
        return { display: '', years: null };
    }
    const close = parseArcimedesDate(el.CLOSE_OF_ESCROW);
    const exp = effectiveLeaseExpirationDate(el);
    if (!close || !exp) {
        return { display: '', years: null };
    }
    const diff = exp - close;
    if (diff !== diff) {
        return { display: '', years: null };
    }
    if (diff <= 0) {
        return { display: 'Expired', years: null };
    }
    const years = Math.round((diff / MS_PER_YEAR) * 2) / 2;
    return { display: years, years };
}

const Print = (props) => {
    const {listings} = props;

    if (!listings) return null;
    const selectedComps = props.comps;
    const query = props.location.query;
    const isHscAgent = props.isHscAgent;
    const isHSC = query.SOURCE === 'HSC' || query.SOURCE === 'PEAK';
    const isClosed = query.CLOSE_OF_ESCROW_MIN || query.CLOSE_OF_ESCROW_MAX || query.STATUS === 'Closed' || peakStatusOf(query) === 'Closed';
    const hasMtInList = listings.some((el) => el.TYPE === 'MT');
    const hasStnlInList = listings.some((el) => el.TYPE === 'STNL');
    let columns = [];
    // Lease Comps functionality has been hidden
    // if(selectedComps === 'lease'){
    //     columns.push(
    //         {
    //             name: 'Category',
    //             render: (el) => capitalizeFirstLetter(el.CATEGORY),
    //             average: false,
    //         },
    //         {
    //             name: 'Type',
    //             render: (el) => el.TYPE,
    //             average: false,
    //         },
    //         {
    //             name: 'Photo',
    //             render: (el) => {
    //                 if (el.WEBSITE_PHOTO_1) {
    //                     const file = el.WEBSITE_PHOTO_1.trim();
    //                     const src = imgSrc(arc.path.media + file, 100, 50);
    //                     return <img src={src} alt='' style={{display: 'block'}}/>
    //                 }
    //                 return null;
    //             },
    //             average: false,
    //         },
    //         {
    //             name: 'Name',
    //             render: (el) => el.NAME,
    //             average: false,
    //         },
    //         {
    //             name: 'Address',
    //             render: (el) => el.ADDRESS,
    //             average: false,
    //         },
    //         {
    //             name: 'City',
    //             render: (el) => el.CITY,
    //             average: false,
    //         },
    //         {
    //             name: 'State',
    //             render: (el) => el.STATE,
    //             average: false,
    //         },
    //         {
    //             name: 'SQFT',
    //             render: (el) => integer(el.SQFT),
    //             average: () => {
    //                 const list = listings.filter(x => x.SQFT).map(x => parseFloat(x.SQFT));
    //                 if (list.length) {
    //                     const sum = list.reduce((a, b) => a + b);
    //                     return integer(sum / list.length);
    //                 } else {
    //                     return null;
    //                 }
    //             },
    //         },
    //         {
    //             name: 'Rent/SQFT',
    //             render: (el) => dollars(el.RENT_PER_SQFT, true),
    //             average: () => {
    //                 const list = listings.filter(x => x.RENT_PER_SQFT).map(x => parseFloat(x.RENT_PER_SQFT));
    //                 if (list.length) {
    //                     const sum = list.reduce((a, b) => a + b);
    //                     return dollars(sum / list.length);
    //                 } else {
    //                     return null;
    //                 }
    //             },
    //         },
    //         {
    //             name: <span>Year<br/>Built</span>,
    //             render: (el) => el.YEAR_BUILT,
    //             average: () => {
    //                 const list = listings.filter(x => x.YEAR_BUILT).map(x => parseFloat(x.YEAR_BUILT));
    //                 if (list.length) {
    //                     const sum = list.reduce((a, b) => a + b);
    //                     return Math.round(sum / list.length);
    //                 } else {
    //                     return null;
    //                 }
    //             },
    //         },
    //         {
    //             name: 'Occupancy',
    //             render: (el) => percent(el.VACANCY, true),
    //             average: () => {
    //                 const list = listings.filter(x => x.VACANCY).map(x => parseFloat(x.VACANCY));
    //                 if (list.length) {
    //                     const sum = list.reduce((a, b) => a + b);
    //                     return percent(sum / list.length);
    //                 } else {
    //                     return null;
    //                 }
    //             },
    //         }
    //         
    //     );
    // }
    if (isHSC) {
        columns.push({
            name: "Status",
            render: (el) => el.HSC_STATUS,
            average: false,
        }, {
            name: 'Property',
            render: (el) => {
                return (
                    <div>
                        <div><strong>{el.NAME}</strong></div>
                        <div>{el.ADDRESS}</div>
                        <div>{el.CITY}, {el.STATE} {el.ZIP}</div>
                    </div>
                )
            },
            average: false,
        }, {
            name: (
                <div>
                    <div>Price</div>
                    <div>Cap Rate</div>
                </div>
            ),
            render: (el) => {
                let price = el.HSC_PRICE;
                let capRate = el.CAPITALIZATION_RATE;

                if (el.HSC_STATUS && el.HSC_STATUS.includes('Closed')) {
                    price = el.SOLD_PRICE;
                    capRate = el.CLOSE_CAP_RATE;
                }

                return (
                    <div>
                        <div>{price == null || price === '' ? '-' : dollars(price)}</div>
                        <div>{capRate == null || capRate === '' ? '-' : percent(capRate)}</div>
                    </div>
                )
            },
            average: () => {
                const parts = [];
                let priceKey = '';
                let capRateKey = '';

                if ((peakStatusOf(query) || '').includes('Closed')) {
                    priceKey = 'SOLD_PRICE';
                    capRateKey = 'CLOSE_CAP_RATE';
                } else {
                    priceKey = 'HSC_PRICE';
                    capRateKey = 'CAPITALIZATION_RATE';
                }

                {
                    const list = listings.filter(x => x[priceKey]).map(x => parseFloat(x[priceKey]));
                    if (list.length) {
                        const sum = list.reduce((a, b) => a + b);
                        parts.push(dollars(Math.round(sum / list.length)));
                    } else {
                        parts.push('-');
                    }
                }
                {
                    const list = listings.filter(x => x[capRateKey]).map(x => parseFloat(x[capRateKey]));
                    if (list.length) {
                        const sum = list.reduce((a, b) => a + b);
                        parts.push(percent(sum / list.length));
                    } else {
                        parts.push('-');
                    }
                }
                return parts.map((x, i) => <div key={i}>{x}</div>);
            },
        }, {
            name: "Loan Amount",
            render: (el) => dollars(el.LOAN_AMOUNT),
            average: () => {
                const list = listings.filter(x => x.LOAN_AMOUNT).map(x => parseInt(x.LOAN_AMOUNT));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return dollars(sum / list.length);
                } else {
                    return null;
                }
            }
        }, {
            name: "LTV",
            render: (el) => percent(el.LTV, false),
            average: () => {
                const list = listings.filter(x => x.LTV).map(x => parseFloat(x.LTV));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return percent(sum / list.length);
                } else {
                    return null;
                }
            }
        }, {
            name: "Down Payment",
            render: (el) => dollars(el.DOWN_PAYMENT),
            average: () => {
                const list = listings.filter(x => x.DOWN_PAYMENT).map(x => parseInt(x.DOWN_PAYMENT));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return dollars(sum / list.length);
                } else {
                    return null;
                }
            }
        }, {
            name: "Rate",
            render: (el) => percent(el.INTEREST_RATE),
            average: () => {
                const list = listings.filter(x => x.INTEREST_RATE).map(x => parseFloat(x.INTEREST_RATE));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return percent(sum / list.length);
                } else {
                    return null;
                }
            }
        }, {
            name: "Amo",
            render: (el) => el.AMORTIZATION,
            average: false,
        }, {
            name: "Term",
            render: (el) => el.TERM,
            average: false,
        }, {
            name: "Lender",
            render: (el) => el.LENDER_NAME,
            average: false,
        });
    } else {
        columns.push({
            name: 'Status',
            render: (el) => el.STATUS,
            average: false,
        });

        if (isClosed) {
            columns.push({
                name: 'Close of Escrow',
                render: (el) => el.CLOSE_OF_ESCROW ? dateISOtoUS(el.CLOSE_OF_ESCROW) : '',
                average: false,
            });
        }

        columns.push(
            {
                name: 'Type',
                render: (el) => el.TYPE,
                average: false,
            },
            {
                name: 'Photo',
                render: (el) => {
                    // The sheet stays mounted (hidden) under the list, so only
                    // load photos while a Sale Comps print is being prepared.
                    if (selectedComps && el.WEBSITE_PHOTO_1) {
                        const file = el.WEBSITE_PHOTO_1.trim();
                        // 2x the printed 90×45 so it stays sharp; the original
                        // is the fallback if the thumbnail service is down.
                        const src = `/api/media-thumbnail?w=180&h=90&path=${encodeURIComponent(file)}`;
                        const fallback = toMediaUrl(file);
                        return <img className='Print_photo' src={src} alt='' onError={(e) => {
                            if (e.currentTarget.src !== fallback) e.currentTarget.src = fallback;
                        }}/>
                    }
                    return null;
                },
                average: false,
            },
            {
                name: 'Property',
                render: (el) => {
                    return (
                        <div>
                            <div><strong>{el.NAME}</strong></div>
                            <div>{el.ADDRESS}</div>
                            <div>{el.CITY}, {el.STATE} {el.ZIP}</div>
                        </div>
                    )
                },
                average: false,
            },
            {
                name: (
                    <div>
                        <div>Price</div>
                        <div>Cap Rate</div>
                        <div>NOI</div>
                    </div>
                ),
                render: (el) => {
                    let price = '';
                    let capRate = '';
                    let noi = '';
                    
                    if (el.STATUS && el.STATUS.includes('Closed')) {
                        price = el.SOLD_PRICE;
                        capRate = el.CLOSE_CAP_RATE;
                        noi = el.CLOSE_NOI;
                    } else if (el.STATUS && (el.STATUS.includes('In Negotiation') || el.STATUS.includes('Under Contract'))) {
                        price = el.NEGOTIATION_PRICE;
                        capRate = el.NEGOTIATION_CAP_RATE;
                        noi = el.NET_OPERATING_INCOME;
                    } else {
                        price = el.LIST_PRICE;
                        capRate = el.CAPITALIZATION_RATE;
                        noi = el.NET_OPERATING_INCOME;
                    }

                    return (
                        <div>
                            <div>{price == null || price === '' ? '-' : dollars(price)}</div>
                            <div>{capRate == null || capRate === '' ? '-' : percent(capRate)}</div>
                            <div>{noi == null || noi === '' ? '-' : dollars(noi)}</div>
                        </div>
                    )
                },
                average: () => {
                    const parts = [];
                    const priceValues = [];
                    const capRateValues = [];
                    const noiValues = [];

                    listings.forEach(el => {
                        let priceKey = 'LIST_PRICE';
                        let capRateKey = 'CAPITALIZATION_RATE';
                        let noiKey = 'NET_OPERATING_INCOME';

                        if (el.STATUS && el.STATUS.includes('Closed')) {
                            priceKey = 'SOLD_PRICE';
                            capRateKey = 'CLOSE_CAP_RATE';
                            noiKey = 'CLOSE_NOI';
                        } else if (el.STATUS && (el.STATUS.includes('In Negotiation') || el.STATUS.includes('Under Contract'))) {
                            priceKey = 'NEGOTIATION_PRICE';
                            capRateKey = 'NEGOTIATION_CAP_RATE';
                        }

                        const p = parseFloat(el[priceKey]);
                        if (!isNaN(p)) priceValues.push(p);

                        const c = parseFloat(el[capRateKey]);
                        if (!isNaN(c)) capRateValues.push(c);

                        const n = parseFloat(el[noiKey]);
                        if (!isNaN(n)) noiValues.push(n);
                    });

                    if (priceValues.length) {
                        parts.push(dollars(Math.round(priceValues.reduce((a, b) => a + b) / priceValues.length)));
                    } else {
                        parts.push('-');
                    }

                    if (capRateValues.length) {
                        parts.push(percent(capRateValues.reduce((a, b) => a + b) / capRateValues.length));
                    } else {
                        parts.push('-');
                    }

                    if (noiValues.length) {
                        parts.push(dollars(Math.round(noiValues.reduce((a, b) => a + b) / noiValues.length)));
                    } else {
                        parts.push('-');
                    }

                    return parts.map((x, i) => <div key={i}>{x}</div>);
                },
            },
        );

        columns.push({
            name: 'SQFT',
            render: (el) => integer(el.SQFT),
            average: () => {
                const list = listings.filter(x => x.SQFT).map(x => parseFloat(x.SQFT));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return integer(sum / list.length);
                } else {
                    return null;
                }
            },
        }, {
            name: 'Rent/SQFT',
            render: (el) => dollars(el.RENT_PER_SQFT, true),
            average: () => {
                const list = listings.filter(x => x.RENT_PER_SQFT).map(x => parseFloat(x.RENT_PER_SQFT));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return dollars(sum / list.length);
                } else {
                    return null;
                }
            },
        });

        if (isClosed) {
            columns.push({
                name: 'Close PSF',
                render: (el) => {
                    if (el.CLOSE_PRICE_PER_SQFT != null && el.CLOSE_PRICE_PER_SQFT !== '') {
                        return dollars(el.CLOSE_PRICE_PER_SQFT, true);
                    }
                    return '';
                },
                average: () => {
                    const list = listings
                        .filter(x => x.CLOSE_PRICE_PER_SQFT != null && x.CLOSE_PRICE_PER_SQFT !== '')
                        .map(x => parseFloat(x.CLOSE_PRICE_PER_SQFT))
                        .filter(x => !isNaN(x));
                    if (list.length) {
                        const sum = list.reduce((a, b) => a + b);
                        return dollars(sum / list.length, true);
                    }
                    return '';
                },
            });
        } else {
            columns.push({
                name: 'PSF',
                render: (el) => {
                    if (el.CLOSE_PRICE_PER_SQFT != null && el.CLOSE_PRICE_PER_SQFT !== '') {
                        return dollars(el.CLOSE_PRICE_PER_SQFT, true);
                    }
                    return '';
                },
                average: () => {
                    const list = listings
                        .filter(x => x.CLOSE_PRICE_PER_SQFT != null && x.CLOSE_PRICE_PER_SQFT !== '')
                        .map(x => parseFloat(x.CLOSE_PRICE_PER_SQFT))
                        .filter(x => !isNaN(x));
                    if (list.length) {
                        const sum = list.reduce((a, b) => a + b);
                        return dollars(sum / list.length, true);
                    }
                    return '';
                },
            });
        }

        columns.push({
            name: <span>Year<br/>Built</span>,
            render: (el) => el.YEAR_BUILT,
            average: () => {
                const list = listings.filter(x => x.YEAR_BUILT).map(x => parseFloat(x.YEAR_BUILT));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return Math.round(sum / list.length);
                } else {
                    return null;
                }
            },
        });

        if (hasMtInList) {
            columns.push({
                name: 'Occupancy',
                render: (el) => (el.TYPE === 'STNL' ? '' : percent(el.VACANCY, true)),
                average: () => {
                    const mtRows = listings.filter((x) => x.TYPE === 'MT');
                    const list = mtRows
                        .filter((x) => x.VACANCY != null && x.VACANCY !== '')
                        .map((x) => parseFloat(x.VACANCY))
                        .filter((v) => !isNaN(v));
                    if (list.length) {
                        const sum = list.reduce((a, b) => a + b);
                        return percent(sum / list.length);
                    }
                    return null;
                },
            });
        }

        if (hasStnlInList) {
            columns.push({
                name: <span>Remaining<br/>Term</span>,
                render: (el) => {
                    const r = remainingLeaseTermAtClose(el);
                    if (r.display === '') return '';
                    if (r.display === 'Expired') return 'Expired';
                    return r.display;
                },
                average: () => {
                    const years = [];
                    listings.forEach((el) => {
                        const r = remainingLeaseTermAtClose(el);
                        if (typeof r.years === 'number' && !isNaN(r.years)) {
                            years.push(r.years);
                        }
                    });
                    if (!years.length) return '';
                    const avg = years.reduce((a, b) => a + b, 0) / years.length;
                    return Math.round(avg * 10) / 10;
                },
            });
        }
    }

    function renderPage({data, isLastPage, pageNo, totalPages}) {
        return (
            <React.Fragment>
                <div className='Print_head'>Sale Comparables</div>
                <div className='Print_body'>
                    <table>
                        <thead>
                        <tr>
                            {
                                columns.map((col, i) => <th key={i}>{col.name}</th>)
                            }
                        </tr>
                        </thead>
                        <tbody>
                        {
                            data.map(x => (
                                <tr key={x.ARCIMEDES_ROW_ID}>
                                    {
                                        columns.map((col, i) => <td key={i}>{col.render(x)}</td>)
                                    }
                                </tr>
                            ))
                        }
                        </tbody>
                        <tfoot style={{display: isLastPage ? '' : 'none'}}>
                        <tr>
                            {
                                (() => {
                                    const idxProperty = columns.findIndex((c) => c.name === 'Property');
                                    if (idxProperty === -1) {
                                        let colspan = 0;
                                        columns.every((x) => {
                                            if (x.average === false) {
                                                colspan++;
                                                return true;
                                            }
                                            return false;
                                        });
                                        return [
                                            <td key="avg-fallback" className="Print_tfoot_label" colSpan={colspan}>AVERAGE:</td>,
                                        ].concat(columns.slice(colspan).map((col, i) => (
                                            <td key={i}>{typeof col.average === 'function' ? col.average() : null}</td>
                                        )));
                                    }
                                    return [
                                        <td key="sp" colSpan={idxProperty}></td>,
                                        <td key="lbl" className="Print_tfoot_label">AVERAGE:</td>,
                                    ].concat(columns.slice(idxProperty + 1).map((col, i) => (
                                        <td key={`a-${i}`}>{typeof col.average === 'function' ? col.average() : null}</td>
                                    )));
                                })()
                            }
                        </tr>
                        </tfoot>
                    </table>
                </div>
                <div className='Print_footer'>
                    <div className='Print_footer_logo'>
                        <img src="img/light-logo.png" alt="Summit RE"/>
                    </div>
                    <div className='Print_footer_info'>
                        <div>Dallas, Houston, SoCal Offices</div>
                        <div>(972) 860-9950 | <a href="https://SummitRE.io">SummitRE.io</a></div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    const noTables =
        listings.length === 0 ? 0 : Math.ceil(listings.length / noPropertiesPerPage);

    return (
        <div className='Print'>
            {
                [...Array(noTables)].map((value, index) => {
                    const isLastPage = index === noTables - 1;
                    const start = index * noPropertiesPerPage;
                    const data = listings.slice(start, start + noPropertiesPerPage);

                    return (
                        <div key={index} className='print-container'>
                            {renderPage({data, isLastPage, pageNo: index + 1, totalPages: noTables})}
                        </div>
                    )
                })
            }
        </div>
    );
};

export default Print;
